<template>
  <main>
    <div class="pra_all">
      <Tou></Tou>
      <div class="dad">
        <ul class="routing">
          <li>
            <span @click="Instructions_YI" class="Instructions">常见问题</span>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class="Instructions" @click="Instructions_ER">游戏</span>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class="Instructions current">QQ冻结问题</span>
            <!-- <div class="border_linear"></div> -->
          </li>
        </ul>
        <ul class="pra_content tong">
          <li class="PC_li">
            <div class="title">
              <div>
                <div>问题:</div>
                为什么QQ会被冻结?
              </div>
            </div>
            <div class="answer">
              <div>答案:</div>
              请注意！这不是被盗号！
              登录出现异常是正常现象，因为玩连接的远程服务器都在云端，和您经常登录QQ所在IP地址不一样，因此触发了腾讯自身的异地登录保护机制。（平时去网吧也会出现这种情况）
              如果账号被冻结了的话，不用担心，简单几步解冻账号~~~~ 操作步骤：
              <div class="asswerheight"></div>
              <br />
              Step1：手机下载QQ安全中心，并登录个人QQ账号 <br />
              <img src="../../../../static/plem01.png" alt="" /> <br />
              <div class="asswerheight"></div>
              Step2：打开QQ安全中心首页——【我的足迹】 <br />
              <img src="../../../../static/plem02.png" alt="" /> <br />
              <div class="asswerheight"></div>
              Step3：找到异地登录的记录，点击进入（若有异地登录，QQ安全中心会标注提示）
              <br />
              <img src="../../../../static/plem03.png" alt="" /> <br />
              <div class="asswerheight"></div>
              Step4：确认是本人登录之后，点击【是我登录，确认无误】，确认该登录没有问题
              <br />
              <img src="../../../../static/plem04.png" alt="" /> <br />
              <div class="asswerheight"></div>
              Step5：返回我的足迹查看，可以看见标注提示已经消除 <br />
              <img src="../../../../static/plem05.png" alt="" /> <br />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
import Tou from "@/components/Tou.vue"  
export default {
  components:{Tou},
  data(){ return {} },
  mounted(){},
  methods:{
    Instructions_YI(){
      this.$router.push('./faq')
    },
    Instructions_ER(){
      this.$router.push('./GameProblem')
    }
  },
}
</script>

<style lang="scss" scoped>
html,
body {
  width: 100%;
  height: 100%;
}
.pra_all {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #100e2e;
}
.current {
  color: #ffffff94;
}
.current:hover {
  color: #ffffff94 !important;
}
.pra_content {
  width: 1070px;
  min-height: 300px;
  padding: 10px 20px 30px 20px;
  margin-top: 30px;
}
.dad {
  margin-top: 170px;
  background-color: #100e2e;
}
.title {
  font-size: 18.3px;
  color: #ffffff;
  width: 1070px;
  font-weight: 900;
}
.title div {
  // text-indent: 25px;
  display: inline-block;
}
.tong {
  margin: 15px auto 0;
  background-color: #0d0b26;
  padding-top: 30px;
}
.PC_li {
  padding: 5px 0 6px 0;
  margin-bottom: 25px;
}
.answer {
  // text-indent: 20px;
  font-size: 16px;
  // color: #ffffff9c;
  color: white;
  width: 100%;
  min-height: 100px !important;
  border-radius: 3px;
  margin-top: 15px;
  padding: 5px 30px;
  background-color: #252e45;
}
.answer div {
  display: inline-block;
}
.asswerheight {
  height: 30px;
  width: 100%;
  background-color: transparent;
  display: block;
}
@media screen and (max-width: 1000px) {
  .tong {
    width: 100%;
  }
  .dad {
    margin-top: 100px;
    background-color: #100e2e;
  }
}
.routing {
  height: 20px;
  width: 1070px;
  margin-top: 70px;
  font-size: 12px;
  line-height: 20px;
  margin: 0 auto;
}
.routing li {
  display: inline;
  position: relative;
}
.Instructions:hover {
  color: white;
  cursor: pointer;
}
@media screen and (max-width: 1000px) {
  .routing {
    width: 100%;
  }
}
.border_linear {
  width: 100% !important;
  height: 1px !important;
  position: absolute;
  left: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(190, 187, 187, 0.1) 0%,
    rgba(190, 187, 187, 0.2) 10%,
    rgba(190, 187, 187, 0.3) 20%,
    rgba(190, 187, 187, 0.4) 30%,
    rgba(190, 187, 187, 0.5) 40%,
    rgba(190, 187, 187, 0.8) 50%,
    rgba(190, 187, 187, 0.5) 60%,
    rgba(190, 187, 187, 0.4) 70%,
    rgba(190, 187, 187, 0.3) 80%,
    rgba(190, 187, 187, 0.2) 90%,
    rgba(190, 187, 187, 0.1) 100%
  );
}
@media screen and (min-width: 999px) and (max-width: 1199px) {
  .dad {
    margin-top: 200px;
  }
}
@media screen and (min-width: 768px) and (max-width: 998px) {
  .dad {
    margin-top: 180px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CommonProblem/GameProblems/Problem_a.vue